<template>
  <VisibilityPlannings variant="confirmed" />
</template>

<script lang="tsx" setup>
import VisibilityPlannings from '@pages/visibility/visibilityPlanning/VisibilityPlannings.vue';
</script>

<style lang="scss" scoped>
</style>
